import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/header";
import Checked from "../../components/icons/checked";
import Loading from "../../components/loading";
import { OrderDetailResponse } from "../../models/order";
import { OrdersService } from "../../services/orders-service";

export default function OrderPlaced() {
  const [orderDetails, setOrderDetails] = useState<OrderDetailResponse>();
  const params = useParams<{ orderId: string }>();

  useEffect(() => {
    (async () => {
      const { orderId } = params;
      if (orderId) {
        const order = await OrdersService.getDetails(orderId);
        setOrderDetails(order);
      }
    })();
  }, [params]);

  if (!orderDetails) return <Loading />;

  const downloadOrder = async () => {
    const { orderId } = params;
    if (orderId) {
      const link = await OrdersService.getS3Link(orderId, "download");

      const a = document.createElement("a");
      a.href = link;

      document.body.appendChild(a);
      a.click();
      a.parentNode!.removeChild(a);
    }
  };

  return (
    <div className="min-h-[90%]">
      <Header>
        <div className="text-3xl font-semibold text-white py-6">
          Order Placed
        </div>
      </Header>
      <div className="bg-[#E6EBF5] rounded-md container mx-auto my-16 flex flex-col gap-8 justify-center items-center p-32">
        <Checked className="h-28 w-28" />
        <div className="font-semibold text-3xl text-primary-blue">
          Thank you for your order!
        </div>
        <div className="-mt-3 font-sourceSansPro font-normal">
          You can now view and download your charts.
        </div>
        <button
          onClick={downloadOrder}
          className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          Download my charts
        </button>
      </div>
    </div>
  );
}
